<template>
  <div>
    <app-header title="" />

    <div class="container my-5">
      <h2>Invoices.</h2>

      <list-filters v-model="params" />

      <c-data-list ref="dataList" :items="invoices" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-2 col-xl-2">
            <p>Number</p>
          </div>
          <div class="col-12 col-lg-3 col-xl-3">
            <p>Client</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2">
            <p>Total</p>
          </div>
          <div class="col-6 col-lg-1 col-xl-1">
            <p>Raised</p>
          </div>
          <div class="col-6 col-lg-1 col-xl-1">
            <p>Due</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">
            <p>Status</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <invoices-list-item :invoice="slotProps.item" />
        </template>
      </c-data-list>
    </div>
  </div>
</template>

<script>
import { isEqual } from "lodash";
import { mapState, mapActions } from "vuex";
import InvoicesListItem from "./InvoicesListItem";
import ListFilters from "./ListFilters";

export default {
  components: {
    InvoicesListItem,
    ListFilters,
  },

  data: function () {
    return {
      loading: true,
      params: {},
    };
  },

  mounted: function () {
    this.getInvoices(this.params);

    this.$watch("params", async (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return;
      }

      await this.getInvoices(this.params);
    });
  },

  computed: {
    ...mapState("invoice", { invoices: "list", pagination: "pagination" }),
  },

  methods: {
    ...mapActions("invoice", {
      getInvoices: "getList",
      getInvoicesForNextPage: "getListForNextPage",
    }),

    async loadNextPage(done) {
      try {
        await this.getInvoicesForNextPage(this.params);

        done();
      } catch (error) {
        done(true);
      }
    },
  },
};
</script>

<style scoped>
</style>